import React, { FC, useEffect, useState } from 'react';

import {
  Text,
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Box,
  Checkbox,
} from '@chakra-ui/react';
import { MdError } from 'react-icons/md';

import { Form, Formik } from 'formik';

import { SiteSelect } from 'components/primitives/SiteSelect';

import FormikDatepicker from 'components/primitives/FormikDatepicker';

import {
  initialValues,
  validationSchema,
} from './AddInventoryCountModal.utils';

import { AddInventoryCountModalViewProps } from './AddInventoryCountModal.props';
import { checkScheduleAvailable } from 'api/inventory';
import { SiteFilterableSelect } from '../SiteFilterableSelect';

const AddInventoryCountModalView: FC<AddInventoryCountModalViewProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const [site, setSite] = useState('');
  const [date, setDate] = useState('');
  const [schedule, setSchedule] = useState<boolean>(false);
  const [isChecked, setIsChecked] = useState(false);
  const storeSiteData = (data: any) => {
    setSite(data);
  };
  const storeDateData = (data: any) => {
    setDate(data);
  };
  const ModalClose = () => {
    setSchedule(false);
    setSite('');
    setDate('');
    setIsChecked(false);
    onClose();
  };
  useEffect(() => {
    if (site && date) {
      checkSchedule();
    }
  }, [site, date]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const checkSchedule = async () => {
    let response = await checkScheduleAvailable(site, date);
    setSchedule(response.item);
    setIsChecked(response.item);
  };
  return (
    <Modal
      size="6xl"
      isCentered
      isOpen={isOpen}
      onClose={ModalClose}
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent p="0px 10px" borderRadius="15px">
        <ModalCloseButton _focus={{ outline: 'none' }} top="5" />
        <ModalHeader
          textAlign="center"
          fontWeight="600"
          color="#262626"
          fontFamily="Poppins">
          Schedule New Inventory Count
        </ModalHeader>
        <ModalBody minH="400px">
          <Flex direction="column" p="40px 80px">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values: any) => {
                setIsChecked(false);
                onSubmit(values);
              }}>
              {({ values }) => (
                <Form>
                  <Flex direction="column" gap="10px">
                    <Flex gap="20px" align="flex-start">
                      <Flex flex={1} direction="column" gap="5px">
                        <SiteFilterableSelect
                          containerProps={{ flex: 1 }}
                          label="Customer Site"
                          name="site"
                          labelProps={{ fontSize: '14px' }}
                          isRequired={true}
                          onChange={storeSiteData}
                        />
                      </Flex>
                      <Flex flex={1}>
                        <FormikDatepicker
                          containerProps={{ isRequired: true }}
                          labelProps={{
                            color: '#afafaf',
                          }}
                          name="countDate"
                          label="Count Date"
                          isEditable={false}
                          onDateChange={storeDateData}
                        />
                      </Flex>
                    </Flex>

                    <Flex
                      mt="30px"
                      justify="center"
                      align="center"
                      direction="column">
                      <Flex align="center" gap="10px">
                        {schedule ? (
                          <Text>✅ Pickup scheduled the same day</Text>
                        ) : (
                          <Flex direction="column" alignItems="center" p={4}>
                            <Flex direction="row">
                              <Box color="red">
                                <MdError size="20px" />
                              </Box>
                              <Text
                                fontWeight="bold"
                                color="red"
                                paddingLeft="10px">
                                No pickup scheduled the same day
                              </Text>
                            </Flex>
                            <Text textAlign="center">
                              To accurately calculate return rates, schedule
                              pickups on the same day as inventory counts.
                            </Text>
                            <Checkbox
                              isChecked={isChecked}
                              onChange={handleCheckboxChange}
                              colorScheme="red"
                              mt={2}>
                              I understand and will schedule the count
                              accordingly.
                            </Checkbox>
                          </Flex>
                        )}
                      </Flex>
                    </Flex>

                    <Flex mt="50px" gap="20px" justify="center">
                      <Button
                        variant="outline"
                        w="200px"
                        onClick={ModalClose}
                        isDisabled={isLoading}>
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        w="200px"
                        isLoading={isLoading}
                        disabled={
                          !isChecked || !values.countDate || !values.site
                        }>
                        Schedule Count
                      </Button>
                    </Flex>
                  </Flex>
                </Form>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddInventoryCountModalView;
